import { Injectable } from "@angular/core";
import { ControlType, Field, Section } from "@cotecna/dynamic-view-engine";
import { HttpService } from "src/app/session/services/http.service";

import { ItFieldInfo } from "../../../inspection/model/it-field-info";

@Injectable({
  providedIn: "root",
})
export class DynamicFormService {
  public constructor(private readonly httpService: HttpService) {}

  private readonly MAX_NUMBER_OF_ITEM_QUANTITY = 2147483647;
  public setEmptyForm(form: Section[]): Section[] {
    if (form?.length) {
      form.forEach((section) => {
        section.fields.forEach((field) => this.setEmptyField(field));
      });
    }
    return form;
  }

  public async setFormValues(
    formValues: ItFieldInfo[],
    naturalForm: Section[],
    naturalControls: any[],
  ): Promise<void> {
    for (const section of naturalForm) {
      for (const field of section.fields) {
        const formValue = formValues.find(
          (formValue) => formValue.fieldId === field.id,
        );
        if (formValue) {
          field.value = formValue.value ?? null;
          field.readableValue = await this.getReadableValue(
            field,
            naturalControls,
          );
        } else this.setEmptyField(field);
      }
    }
  }

  public setEmptyField(field: Field) {
    switch (field.type) {
      case ControlType.MultiDropdown:
        field.value = [];
        field.readableValue = [];
        break;
      default:
        field.value = null;
        field.readableValue = null;
    }
  }

  public async getReadableValue(
    field: Field,
    naturalControls: any[],
  ): Promise<string[]> {
    if (
      (field.type === ControlType.MultiDropdown ||
        field.type === ControlType.Dropdown) &&
      field.value
    ) {
      let options: any;
      const datasourceUrl = naturalControls.find(
        (control) => control.id === field.id,
      ).datasourceUrl;

      if (datasourceUrl) {
        options = await this.httpService.get(datasourceUrl).toPromise();
      } else {
        options = naturalControls.find(
          (control) => control.id === field.id,
        ).options;
      }

      const selectedOptions = options.filter((option) =>
        field.value.includes(option.id),
      );
      const readableValue = [];
      if (selectedOptions?.length) {
        selectedOptions.forEach((selectedOption) => {
          readableValue.push(selectedOption.name);
        });
      }
      return readableValue;
    }
    return [""];
  }

  public hasInvalidQuantity(itemQuantity: number): boolean {
    return itemQuantity > this.MAX_NUMBER_OF_ITEM_QUANTITY || itemQuantity < 0;
  }
}

export interface NaturalFormConverterResult {
  sections: Section[];
  controls: any[];
}

export interface SectionForPresetInForm {
  sectionId: string;
  sectionName: string;
  containsGroup?: boolean;
  parentId?: string;
  selected?: boolean;
}
